import { FormBuilder, FormGroup} from "@angular/forms";
import {
    CalendarEvent,
    CalendarEventAction,
    CalendarEventTimesChangedEvent
  } from 'angular-calendar';

export interface Mortgage
{
    id : number,
    lead_level : string,
    salse_rep_name : string,
    created_date : string,
    disposition:string,
    queued:number,
    didpick:number,
    dispoattempts:number,
    callback_time:number,
    dispodate:string,
    edit : Edit,
    personalinfo : PersonalInfo,
    current_script: Scripts,
    comments : Comments,
    dispodata : DispoData,
    apptcalendardata : ApptCalendar,
    objection_id:string,
    pdf:string,
    questions : Questions,
    attempt:number,
    lastcall:string
}

/* export interface Soktmortgage
{
    name:string
} */

export interface HTTPMortgage
{
    id : number,
    lead_level : string,
    salse_rep_name : string,
    created_date : string,
    disposition:string,
    queued:number,
    didpick:number,
    dispoattempts:number,
    callback_time:number,
    dispodate:string,
    edit : Edit,
    personalinfo : PersonalInfo,
    current_script: Scripts,
    comments : Comments,
    dispodata : DispoData,
    apptcalendardata : ApptCalendar,
    objection_id:string,
    pdf:string,
    questions : Questions
}

export class MortgageForm implements HTTPMortgage
{
    public id:number;
    public lead_level : string;
    public salse_rep_name : string;
    public created_date : string;
    public disposition:string;
    public queued:number;
    public didpick:number;
    public dispoattempts:number;
    public callback_time:number;
    public dispodate:string;
    public edit : Edit;
    public personalinfo : PersonalInfo;
    public current_script: Scripts;
    public comments : Comments;
    public dispodata : DispoData;
    public apptcalendardata : ApptCalendar;
    public objection_id:string;
    public pdf:string;
    public questions : Questions;
    
    constructor(data: Mortgage)
    {
        if(data == null)
        {
            this.id=-1;
            this.lead_level="testing level";
            this.salse_rep_name="test sales ";
            this.created_date="testing created date";
            this.disposition="";
            this.queued=-1;
            this.didpick=-1;
            this.dispoattempts=-1;
            this.callback_time=-1;
            this.dispodate="";
            this.edit=new EditForm(null);
            this.personalinfo=new PersonalInfoForm(null);
            this.current_script=new FormScripts(null);
            this.comments=new CommentsForm(null);
            this.dispodata=new FormDispoData(null);
            this.apptcalendardata=new ApptCalendarForm(null);
            this.objection_id="-1";
            this.pdf = "";
            this.questions = new QuestionsForm(null);
        }
        else
        {
            this.id=data.id;
            this.lead_level=data.lead_level;
            this.salse_rep_name=data.salse_rep_name;
            this.created_date=data.created_date;
            this.disposition=data.disposition;
            this.queued=data.queued;
            this.didpick=data.didpick;
            this.dispoattempts=data.dispoattempts;
            this.callback_time=data.callback_time;
            this.dispodate=data.dispodate;
            this.edit=new EditForm(data.edit);
            this.personalinfo=new PersonalInfoForm(data.personalinfo);
            this.current_script=data.current_script;
            this.comments=new CommentsForm(data.comments);          
            this.dispodata=new FormDispoData(data.dispodata);
            this.apptcalendardata=new ApptCalendarForm(data.apptcalendardata);
            this.objection_id=data.objection_id;
            this.pdf = data.pdf;
            this.questions = new QuestionsForm(data.questions)
        }
    }

    set script(val:Scripts)
    {       
        val.script_body = val.script_body.replace(/{AGENT_FIRSTNAME}/g, sessionStorage.getItem("firstname"));
        if(sessionStorage.getItem("lastname") != null && sessionStorage.getItem("lastname") != undefined)
            val.script_body = val.script_body.replace(/{AGENT_LASTNAME}/g, sessionStorage.getItem("lastname"));
        else
            val.script_body = val.script_body.replace(/{AGENT_LASTNAME}/g, '');
        val.script_body = val.script_body.replace(/{AGENT_FULLNAME}/g, sessionStorage.getItem("fullname"));
        val.script_body = val.script_body.replace(/{AGENT_CONTACT}/g, sessionStorage.getItem("contact"));
        val.script_body = val.script_body.replace(/{AGENT_EMAIL}/g, sessionStorage.getItem("email"));
        if(this.lead_level)
            val.script_body = val.script_body.replace(/{LEAD_LEVEL}/g, this.lead_level);
        if(this.created_date)
            val.script_body = val.script_body.replace(/{CREATED_DATE}/g, this.created_date);
        if(this.disposition)
            val.script_body = val.script_body.replace(/{DISPOSITION}/g, this.disposition);
        if(this.edit.first_name)
            val.script_body = val.script_body.replace(/{FIRST_NAME}/g, this.edit.first_name);
        if(this.edit.last_name)
            val.script_body = val.script_body.replace(/{LAST_NAME}/g, this.edit.last_name);
        if(this.edit.street_address_1)
            val.script_body = val.script_body.replace(/{STREET_ADDRESS_1}/g, this.edit.street_address_1);
        if(this.edit.spouse_full_name)
            val.script_body = val.script_body.replace(/{SPOUSE_FULL_NAME}/g, this.edit.spouse_full_name);
        if(this.edit.city)
            val.script_body = val.script_body.replace(/{CITY}/g, this.edit.city);
        if(this.edit.state)
            val.script_body = val.script_body.replace(/{STATE}/g, this.edit.state);
        if(this.edit.zip)
            val.script_body = val.script_body.replace(/{ZIP}/g, this.edit.zip);
        if(this.edit.lead_source)
            val.script_body = val.script_body.replace(/{LEAD_SOURCE}/g, this.edit.lead_source);
        if(this.personalinfo.lead_source)
            val.script_body = val.script_body.replace(/{LEAD_SOURCE}/g, this.personalinfo.lead_source);
        if(this.edit.county)
            val.script_body = val.script_body.replace(/{COUNTY}/g, this.edit.county);
        if(this.edit.email)
            val.script_body = val.script_body.replace(/{EMAIL}/g, this.edit.email);
        if(this.edit.cell_phone)
            val.script_body = val.script_body.replace(/{CELL_PHONE}/g, this.edit.cell_phone);
        if(this.edit.phone)
            val.script_body = val.script_body.replace(/{PHONE}/g, this.edit.phone);
        if(this.edit.work_phone)
            val.script_body = val.script_body.replace(/{WORK_PHONE}/g, this.edit.work_phone);
        if(this.personalinfo.birth_date)
            val.script_body = val.script_body.replace(/{BIRTH_DATE}/g, this.personalinfo.birth_date);
        if(this.personalinfo.spouse_birth_date)
            val.script_body = val.script_body.replace(/{SPOUSE_BIRTH_DATE}/g, this.personalinfo.spouse_birth_date);
        if(this.personalinfo.age)
            val.script_body = val.script_body.replace(/{AGE}/g, this.personalinfo.age);
        if(this.personalinfo.spouse_age)
            val.script_body = val.script_body.replace(/{SPOUSE_AGE}/g, this.personalinfo.spouse_age);
        if(this.personalinfo.occupation)
            val.script_body = val.script_body.replace(/{OCCUPATION}/g, this.personalinfo.occupation);
        if(this.personalinfo.spouse_occupation)
            val.script_body = val.script_body.replace(/{SPOUSE_OCCUPATION}/g, this.personalinfo.spouse_occupation);
        if(this.personalinfo.height)
            val.script_body = val.script_body.replace(/{HEIGHT}/g, this.personalinfo.height);
        if(this.personalinfo.spouse_height)
            val.script_body = val.script_body.replace(/{SPOUSE_HEIGHT}/g, this.personalinfo.spouse_height);
        if(this.personalinfo.weight)
            val.script_body = val.script_body.replace(/{WEIGHT}/g, this.personalinfo.weight);
        if(this.personalinfo.spouse_weight)
            val.script_body = val.script_body.replace(/{SPOUSE_WEIGHT}/g, this.personalinfo.spouse_weight);
        if(this.personalinfo.smoker)
            val.script_body = val.script_body.replace(/{SMOKER}/g, this.personalinfo.smoker);
        if(this.personalinfo.spouse_smoker)
            val.script_body = val.script_body.replace(/{SPOUSE_SMOKER}/g, this.personalinfo.spouse_smoker);
        if(this.personalinfo.health_issue)
            val.script_body = val.script_body.replace(/{HEALTH_ISSUE}/g, this.personalinfo.health_issue);
        if(this.personalinfo.spouse_health_issue)
            val.script_body = val.script_body.replace(/{SPOUSE_HEALTH_ISSUE}/g, this.personalinfo.spouse_health_issue);
        if(this.personalinfo.lender)
            val.script_body = val.script_body.replace(/{LENDER}/g, this.personalinfo.lender);
        if(this.personalinfo.beneficiary)
            val.script_body = val.script_body.replace(/{BENEFICIARY}/g, this.personalinfo.beneficiary);
        if(this.personalinfo.mortgage_amount)
            val.script_body = val.script_body.replace(/{MORTGAGE_AMOUNT}/g, this.personalinfo.mortgage_amount);
        if(this.personalinfo.lead_level)
            val.script_body = val.script_body.replace(/{LEAD_LEVEL}/g, this.personalinfo.lead_level);
        if(this.personalinfo.purchase_refi)
            val.script_body = val.script_body.replace(/{PURCHASE_REFI}/g, this.personalinfo.purchase_refi);
        if(this.personalinfo.assign_date)
            val.script_body = val.script_body.replace(/{ASSIGN_DATE}/g, this.personalinfo.assign_date);
        if(this.personalinfo.home_value)
            val.script_body = val.script_body.replace(/{HOME_VALUE}/g, this.personalinfo.home_value);
        if(this.personalinfo.status)
            val.script_body = val.script_body.replace(/{STATUS}/g, this.personalinfo.status);
        if(this.personalinfo.mortgage_term)
            val.script_body = val.script_body.replace(/{MORTGAGE_TERM}/g, this.personalinfo.mortgage_term);
        if(this.personalinfo.referrer)
            val.script_body = val.script_body.replace(/{REFERRER}/g, this.personalinfo.referrer);
        if(this.personalinfo.monthly_mortage_payment)
            val.script_body = val.script_body.replace(/{MONTHLY_MORTAGE_PAYMENT}/g, this.personalinfo.monthly_mortage_payment);
        if(this.personalinfo.field_1)
            val.script_body = val.script_body.replace(/{FIELD_1}/g, this.personalinfo.field_1);
        if(this.personalinfo.field_2)
            val.script_body = val.script_body.replace(/{FIELD_2}/g, this.personalinfo.field_2);         
        if(this.personalinfo.field_3)
            val.script_body = val.script_body.replace(/{FIELD_3}/g, this.personalinfo.field_3);         
        if(this.personalinfo.field_4)
            val.script_body = val.script_body.replace(/{FIELD_4}/g, this.personalinfo.field_4);
        if(this.personalinfo.field_5)
            val.script_body = val.script_body.replace(/{FIELD_5}/g, this.personalinfo.field_5);
        if(this.personalinfo.field_6)
            val.script_body = val.script_body.replace(/{FIELD_6}/g, this.personalinfo.field_6);         
        if(this.personalinfo.field_7)
            val.script_body = val.script_body.replace(/{FIELD_7}/g, this.personalinfo.field_7);
        if(this.personalinfo.field_8)
            val.script_body = val.script_body.replace(/{FIELD_8}/g, this.personalinfo.field_8);
        if(this.personalinfo.field_9)
            val.script_body = val.script_body.replace(/{FIELD_9}/g, this.personalinfo.field_9);
        if(this.personalinfo.field_10)
            val.script_body = val.script_body.replace(/{FIELD_10}/g, this.personalinfo.field_10);
        if(this.personalinfo.field_11)
            val.script_body = val.script_body.replace(/{FIELD_11}/g, this.personalinfo.field_11);
        if(this.personalinfo.field_12)
            val.script_body = val.script_body.replace(/{FIELD_12}/g, this.personalinfo.field_12);
        if(this.personalinfo.field_13)
            val.script_body = val.script_body.replace(/{FIELD_13}/g, this.personalinfo.field_13);
        if(this.personalinfo.field_14)
            val.script_body = val.script_body.replace(/{FIELD_14}/g, this.personalinfo.field_14);
        if(this.personalinfo.field_15)
            val.script_body = val.script_body.replace(/{FIELD_15}/g, this.personalinfo.field_15);
        if(this.personalinfo.field_16)
            val.script_body = val.script_body.replace(/{FIELD_16}/g, this.personalinfo.field_16);
        if(this.personalinfo.field_17)
            val.script_body = val.script_body.replace(/{FIELD_17}/g, this.personalinfo.field_17);
        if(this.personalinfo.field_18)
            val.script_body = val.script_body.replace(/{FIELD_18}/g, this.personalinfo.field_18);
        if(this.personalinfo.field_19)
            val.script_body = val.script_body.replace(/{FIELD_19}/g, this.personalinfo.field_19);
        if(this.personalinfo.field_20)
            val.script_body = val.script_body.replace(/{FIELD_20}/g, this.personalinfo.field_20);
        if(this.personalinfo.field_21)
            val.script_body = val.script_body.replace(/{FIELD_21}/g, this.personalinfo.field_21);
        if(this.personalinfo.field_22)
            val.script_body = val.script_body.replace(/{FIELD_22}/g, this.personalinfo.field_22);
        if(this.personalinfo.field_23)
            val.script_body = val.script_body.replace(/{field_23}/g, this.personalinfo.field_23);
        if(this.personalinfo.field_18)
            val.script_body = val.script_body.replace(/{FIELD_18}/g, this.personalinfo.field_18);
        if(this.personalinfo.field_19)
            val.script_body = val.script_body.replace(/{FIELD_19}/g, this.personalinfo.field_19);
        if(this.personalinfo.field_20)
            val.script_body = val.script_body.replace(/{FIELD_20}/g, this.personalinfo.field_20);
        if(this.personalinfo.field_21)
            val.script_body = val.script_body.replace(/{FIELD_21}/g, this.personalinfo.field_21);
        if(this.personalinfo.field_22)
            val.script_body = val.script_body.replace(/{FIELD_22}/g, this.personalinfo.field_22);
        if(this.personalinfo.field_23)
            val.script_body = val.script_body.replace(/{field_23}/g, this.personalinfo.field_23);
        if(this.personalinfo.field_24)
            val.script_body = val.script_body.replace(/{field_24}/g, this.personalinfo.field_24);
        if(this.personalinfo.field_25)
            val.script_body = val.script_body.replace(/{FIELD_25}/g, this.personalinfo.field_25);
        if(this.personalinfo.field_26)
            val.script_body = val.script_body.replace(/{FIELD_26}/g, this.personalinfo.field_26);
        if(this.personalinfo.field_27)
            val.script_body = val.script_body.replace(/{FIELD_27}/g, this.personalinfo.field_27);
        if(this.personalinfo.field_28)
            val.script_body = val.script_body.replace(/{FIELD_28}/g, this.personalinfo.field_28);
        if(this.personalinfo.field_29)
            val.script_body = val.script_body.replace(/{FIELD_29}/g, this.personalinfo.field_29);
        if(this.personalinfo.field_30)
            val.script_body = val.script_body.replace(/{FIELD_30}/g, this.personalinfo.field_30);
        if(this.personalinfo.field_31)
            val.script_body = val.script_body.replace(/{FIELD_31}/g, this.personalinfo.field_31);
        if(this.personalinfo.field_32)
            val.script_body = val.script_body.replace(/{FIELD_32}/g, this.personalinfo.field_32);
        if(this.personalinfo.field_33)
            val.script_body = val.script_body.replace(/{FIELD_33}/g, this.personalinfo.field_33);
        if(this.personalinfo.field_34)
            val.script_body = val.script_body.replace(/{FIELD_34}/g, this.personalinfo.field_34);
        if(this.personalinfo.field_35)
            val.script_body = val.script_body.replace(/{FIELD_35}/g, this.personalinfo.field_35);
        if(this.personalinfo.field_36)
            val.script_body = val.script_body.replace(/{FIELD_36}/g, this.personalinfo.field_36);
        if(this.personalinfo.field_37)
            val.script_body = val.script_body.replace(/{FIELD_37}/g, this.personalinfo.field_37);
        if(this.personalinfo.field_38)
            val.script_body = val.script_body.replace(/{FIELD_38}/g, this.personalinfo.field_38);
        if(this.personalinfo.field_39)
            val.script_body = val.script_body.replace(/{FIELD_39}/g, this.personalinfo.field_39);
        if(this.personalinfo.field_40)
            val.script_body = val.script_body.replace(/{FIELD_40}/g, this.personalinfo.field_40);
        if(this.personalinfo.field_41)
            val.script_body = val.script_body.replace(/{FIELD_41}/g, this.personalinfo.field_41);
        if(this.personalinfo.field_42)
            val.script_body = val.script_body.replace(/{FIELD_42}/g, this.personalinfo.field_42);
        if(this.personalinfo.field_43)
            val.script_body = val.script_body.replace(/{FIELD_43}/g, this.personalinfo.field_43);
        if(this.personalinfo.field_44)
            val.script_body = val.script_body.replace(/{FIELD_44}/g, this.personalinfo.field_44);
        if(this.personalinfo.field_45)
            val.script_body = val.script_body.replace(/{FIELD_45}/g, this.personalinfo.field_45);
        if(this.personalinfo.field_46)
            val.script_body = val.script_body.replace(/{FIELD_46}/g, this.personalinfo.field_46);
        if(this.personalinfo.field_47)
            val.script_body = val.script_body.replace(/{FIELD_47}/g, this.personalinfo.field_47);
        if(this.personalinfo.field_48)
            val.script_body = val.script_body.replace(/{FIELD_48}/g, this.personalinfo.field_48);
        if(this.personalinfo.field_49)
            val.script_body = val.script_body.replace(/{FIELD_49}/g, this.personalinfo.field_49);
        if(this.personalinfo.field_50)
            val.script_body = val.script_body.replace(/{FIELD_50}/g, this.personalinfo.field_50);
        console.log(val);
        this.current_script=val;
    }
}

// staring for Edit  module
export interface Edit 
{
    [x: string]: any;
    fullname : string,
    first_name : string,
    last_name : string,
    street_address_1 : string,
    spouse_full_name        : string,
    city : string,
    state : string,
    zip : string,
    county : string,
    email : string,
    cell_phone : string,
    phone : string,
    work_phone : string,
    timezone : string,
    lead_source: string,
    assign_date:string

}

export interface HTTPEdit
{
    first_name : string,
    last_name : string,
    fullname : string,
    street_address_1 : string,
    spouse_full_name        : string,
    city : string,
    state : string,
    zip : string,
    county : string,
    email : string,
    cell_phone : string,
    phone : string,
    work_phone : string,
    timezone : string,
    lead_source: string,
    assign_date:string
}

export class EditForm implements HTTPEdit{
    public first_name : string;
    public  last_name : string;
    public fullname : string;
    public  street_address_1 : string;
    public  spouse_full_name : string;
    public  city : string;
    public state : string;
    public zip : string;
    public county : string;
    public email : string;
    public cell_phone : string;
    public phone : string;
    public work_phone : string;
    public timezone : string;
    public lead_source: string;
    public assign_date:string
    
    constructor(data : Edit) 
    {
        if(data==null)
        {
            this.first_name="";
            this.last_name="";
            this.fullname=this.first_name+" "+this.last_name;
            this.street_address_1="";
            this.spouse_full_name="";
            this.city="";
            this.state="",
            this.zip="";
            this.county="";
            this.email="";
            this.cell_phone="";
            this.phone="";
            this.work_phone="";
            this.timezone="";
            this.lead_source="";
            this.assign_date=""
            
        }
        else
        {
            this.first_name=data.first_name;
            if(data.last_name)
                this.last_name=data.last_name;
            else
                this.last_name="";
            this.fullname=this.first_name.toUpperCase()+" "+this.last_name.toUpperCase();
            this.street_address_1=data.street_address_1;
            this.spouse_full_name = data.spouse_full_name;
            this.city=data.city;
            this.state=data.state;
            this.zip=data.zip;
            this.county=data.county;
            this.email=data.email;
            this.timezone = data.timezone;
            this.lead_source = data.lead_source;
            this.assign_date=data.assign_date
            var numberPattern = /\d+/g;


            let cellnum = data.cell_phone;
            if(cellnum != null && cellnum != undefined && cellnum != "null" && cellnum != "")
            {
                let cellno = (cellnum).match(numberPattern);

                cellnum = '';
                if(cellno !=null || cellno!=undefined)
                {
                    cellno.forEach(val=>{
                        cellnum += val;
                    })
                    // if(cellnum.length==10)
                    //     cellnum = '1'+cellnum;
                }
                
            }
            this.cell_phone=cellnum;

            let homenum = data.phone;
            if(homenum != null && homenum != undefined && homenum != "null" && homenum != "")
            {
                let homeno = (homenum).match(numberPattern);
                
                homenum = "";
                if(homeno !=null || homeno!=undefined)
                {
                    homeno.forEach(val=>{
                        homenum += val;
                    })
                    // if(homenum.length==10)
                    //     homenum = '1'+homenum;
                }
                
            }
            this.phone=homenum;

            let worknum = data.work_phone;
            if(worknum != null && worknum != undefined && worknum != "null" && worknum != "")
            {
                let workno = (worknum).match(numberPattern);
                
                worknum = '';
                if(workno !=null || workno!=undefined)
                {
                    workno.forEach(val=>{
                        worknum += val;
                    })
                    // if(worknum.length==10)
                    //     worknum = '1'+worknum;
                }
                
            }
            this.work_phone=worknum;           
        }
    }

    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
            first_name: [this.first_name],
            last_name: [this.last_name],
            fullname: [this.fullname],
            street_address_1: [this.street_address_1],
            spouse_full_name: [this.spouse_full_name],
            city: [this.city],
            state: [this.state],
            zip: [this.zip],
            county: [this.county],
            email: [this.email],
            cell_phone: [this.cell_phone],
            phone: [this.phone],
            work_phone: [this.work_phone],
            timezone: [this.timezone],
            lead_source : [this.lead_source],
            assign_date:[this.assign_date]
        });
    }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {

           this.first_name=fg.get("first_name").value;
            this.last_name=fg.get("last_name").value;
            this.fullname=fg.get("fullname").value;
            this.street_address_1=fg.get("street_address_1").value;
            this.spouse_full_name = fg.get("spouse_full_name").value;
            this.city=fg.get("city").value;
            this.state=fg.get("state").value;
            this.zip=fg.get("zip").value;
            this.county=fg.get("county").value;
            this.email=fg.get("email").value;
            this.cell_phone=fg.get("cell_phone").value;
            this.phone=fg.get("phone").value;
            this.timezone=fg.get("timezone").value;
            this.lead_source = fg.get("lead_source").value;
            this.assign_date=fg.get("assign_date").value
            return true;
        }
        else
        {
            return false;
        }
    }
  }

  //End Edit form


  // Starting  PersonalInfo Module

  export interface PersonalInfo{
    lead_source:          string;
    birth_date              : string,
    spouse_birth_date       : string,
    age                     : string,
    spouse_age              : string, 
    occupation              : string,
    spouse_occupation       : string,
    height                  : string,
    spouse_height           : string,
    weight                  : string,
    spouse_weight           : string,
    smoker                  : string,
    spouse_smoker           : string,
    health_issue            : string,
    spouse_health_issue     : string,
    lender                  : string,
    beneficiary             : string,
    mortgage_amount         : string,
    lead_level              : string,
    purchase_refi           : string,
    assign_date             : string,
    home_value              : string,
    status                  : string,
    mortgage_term           : string,
    referrer                : string,
    monthly_mortage_payment : string,
    reason                  : string,
    field_1                  : string,
    field_2                  : string,
    field_3                  : string,
    field_4                  : string,
    field_5                  : string,
    field_6                  : string,
    field_7                  : string,
    field_8                  : string,
    field_9                  : string,
    field_10                  : string,
    field_11                  : string,
    field_12                  : string,
    field_13                  : string,
    field_14                  : string,
    field_15                  : string,
    field_16                  : string,
    field_17                  : string,
    field_18                 : string,
    field_19                  : string,
    field_20                  : string,
    field_21                  : string,
    field_22                  : string,
    field_23                  : string,
    field_24                  : string,
    field_25                  : string,
    field_26                  : string,
    field_27                  : string,
    field_28                  : string,
    field_29                  : string,
    field_30                 : string,
    field_31                  : string,
    field_32                  : string,
    field_33                  : string,
    field_34                  : string,
    field_35                  : string,
    field_36                  : string,
    field_37                  : string,
    field_38                  : string,
    field_39                  : string,
    field_40                  : string,
    field_41                  : string,
    field_42                  : string,
    field_43                  : string,
    field_44                  : string,
    field_45                  : string,
    field_46                  : string,
    field_47                  : string,
    field_48                  : string,
    field_49                  : string,
    field_50                  : string,

     /* @@ recruiting form fields */
     job                      : string,
     notes                    : string,
     rating                   : string,
     star_rating              : string,
     labels                   : string,
     candidate_overview       : string,
     ques_ans                 : string,    
     disposition              : string,
     resume                   : string,
     dealbreakerquescorrect   : string,
     duration                 : string,
     recent_comp              : string,
     recent_post              : string,
     recent_pay               : string,
     school                   : string,
     major                    : string,
     degree                   : string,
     exp                      : string,
}

export interface HTTPPersonalInfo
{
    lead_source             : string;
    birth_date              : string,
    spouse_birth_date       : string,
    age                     : string,
    spouse_age              : string, 
    occupation              : string,
    spouse_occupation       : string,
    height                  : string,
    spouse_height           : string,
    weight                  : string,
    spouse_weight           : string,
    smoker                  : string,
    spouse_smoker           : string,
    health_issue            : string,
    spouse_health_issue     : string,
    lender                  : string,
    beneficiary             : string,
    mortgage_amount         : string,
    lead_level              : string,
    purchase_refi           : string,
    assign_date             : string,
    home_value              : string,
    status                  : string,
    mortgage_term           : string,
    referrer                : string,
    monthly_mortage_payment : string,
    reason                  : string,
    field_1                  : string,
    field_2                  : string,
    field_3                  : string,
    field_4                  : string,
    field_5                  : string,
    field_6                  : string,
    field_7                  : string,
    field_8                  : string,
    field_9                  : string,
    field_10                  : string,
    field_11                  : string,
    field_12                  : string,
    field_13                  : string,
    field_14                  : string,
    field_15                  : string,
    field_16                  : string,
    field_17                  : string,
    field_18                 : string,
    field_19                  : string,
    field_20                  : string,
    field_21                  : string,
    field_22                  : string,
    field_23                  : string,
    field_24                  : string,
    field_25                  : string,
    field_26                  : string,
    field_27                  : string,
    field_28                  : string,
    field_29                  : string,
    field_30                 : string,
    field_31                  : string,
    field_32                  : string,
    field_33                  : string,
    field_34                  : string,
    field_35                  : string,
    field_36                  : string,
    field_37                  : string,
    field_38                  : string,
    field_39                  : string,
    field_40                  : string,
    field_41                  : string,
    field_42                  : string,
    field_43                  : string,
    field_44                  : string,
    field_45                  : string,
    field_46                  : string,
    field_47                  : string,
    field_48                  : string,
    field_49                  : string,
    field_50                  : string,

    /* @@ recruiting form fields */
    job                      : string,
    notes                    : string,
    rating                   : string,
    star_rating              : string,
    labels                   : string,
    candidate_overview       : string,
    ques_ans                 : string,    
    disposition              : string,
    resume                   : string,
    dealbreakerquescorrect   : string,
    duration                 : string,
    recent_comp              : string,
    recent_post              : string,
    recent_pay               : string,
    school                   : string,
    major                    : string,
    degree                   : string,
    exp                      : string,
    
}

export class PersonalInfoForm implements HTTPPersonalInfo{
    public lead_source : string;
    public  birth_date : string;
    public  age : string;
    public occupation : string;
    public spouse_occupation : string;
    public  spouse_birth_date : string;
    public  spouse_age : string;
    public  lender : string;
    public mortgage_amount : string;
    public purchase_refi : string;
    public  home_value : string;
    public  mortgage_term : string;
    public  monthly_mortage_payment : string;
    public   beneficiary : string;
    public  smoker : string;
    public  height : string;
    public  weight : string;
    public  health_issue : string;
    public  spouse_smoker : string;
    public  spouse_height : string;
    public  spouse_weight : string;
    public   spouse_health_issue : string;
    public  lead_level : string;
    public  assign_date : string;
    public   status : string;
    public   referrer : string;
    public reason:string;
    public field_1                  : string;
    public field_2                  : string;
    public field_3                  : string;
    public field_4                  : string;
    public field_5                  : string;
    public field_6                  : string;
    public field_7                  : string;
    public field_8                  : string;
    public field_9                  : string;
    public field_10                  : string;
    public field_11                  : string;
    public field_12                  : string;
    public field_13                  : string;
    public field_14                  : string;
    public field_15                  : string;
    public field_16                  : string;
    public field_17                  : string;
    public field_18                 : string;
    public field_19                  : string;
    public field_20                  : string;
    public field_21                  : string;
    public field_22                  : string;
    public field_23                  : string;
    public field_24                  : string;
    public field_25                  : string;
    public field_26                  : string;
    public field_27                  : string;
    public field_28                  : string;
    public field_29                  : string;
    public field_30                 : string;
    public field_31                  : string;
    public field_32                  : string;
    public field_33                  : string;
    public field_34                  : string;
    public field_35                  : string;
    public field_36                  : string;
    public field_37                  : string;
    public field_38                  : string;
    public field_39                  : string;
    public field_40                  : string;
    public field_41                  : string;
    public field_42                  : string;
    public field_43                  : string;
    public field_44                  : string;
    public field_45                  : string;
    public field_46                  : string;
    public field_47                  : string;
    public field_48                  : string;
    public field_49                  : string;
    public field_50                  : string;

    /* @@ recruiting edit fields */
    public  job                      : string; 
    public  notes                    : string
    public rating                    : string;
    public star_rating               : string;
    public labels                    : string;
    public candidate_overview        : string;
    public ques_ans                  : string;
    public disposition               : string;
    public resume                    : string;
    public dealbreakerquescorrect    : string;
    public duration                  : string;
    public recent_comp               : string;
    public recent_post               : string;
    public recent_pay                : string;
    public school                    : string;
    public major                     : string;
    public degree                    : string;
    public exp                       : string;

    
    constructor(data : PersonalInfo) 
    {
        if(data==null)
        {
            this.lead_source="";
            this.birth_date="";
            this.age="";
            this.occupation="";
            this.spouse_occupation="",
            this.spouse_birth_date="";
            this.spouse_age="";
            this.lender="";
            this.mortgage_amount="";
            this.purchase_refi="";
            this.home_value="";
            this.mortgage_term="";
            this.monthly_mortage_payment="";
            this.beneficiary="";
            this.smoker="";
            this.height="";
            this.weight="";
            this.health_issue="";
            this.spouse_smoker="";
            this.spouse_height="";
            this.spouse_weight="";
            this.spouse_health_issue="";
            this.lead_level="";
            this.assign_date="";
            this.status="";
            this.referrer="";
            this.reason=""; 
            this.field_1                  ="field 1"
            this.field_2                  ="field 2"
            this.field_3                  ="field 3"
            this.field_4                  ="field 4"
            this.field_5                  ="field 5"
            this.field_6                  ="field 6"
            this.field_7                  ="field 7"
            this.field_8                  ="field 8"
            this.field_9                  ="field 9"
           this.field_10                  ="field 10"
           this.field_11                  ="field 11"
           this.field_12                  ="field 12"
           this.field_13                  ="field 13"
           this.field_14                  ="field 14"
           this.field_15                  ="field 15"
           this.field_16                  ="field 16"
           this.field_17                  ="field 17"
           this.field_18                  ="field 18"
           this.field_19                  ="field 19"
           this.field_20                  ="field 20"
           this.field_21                  ="field 21"
           this.field_22                  ="field 22"
           this.field_23                  ="field 23"
           this.field_24                  ="field 24"
           this.field_25                  ="field 25"
           this.field_26                  ="field 26"
           this.field_27                  ="field 27"
           this.field_28                  ="field 28"
           this.field_29                  ="field 29"
           this.field_30                  ="field 30"
           this.field_31                  ="field 31"
           this.field_32                  ="field 32"
           this.field_33                  ="field 33"
           this.field_34                  ="field 34"
           this.field_35                  ="field 35"
           this.field_36                  ="field 36"
           this.field_37                  ="field 37"
           this.field_38                  ="field 38"
           this.field_39                  ="field 39"
           this.field_40                  ="field 40"
           this.field_41                  ="field 41"
           this.field_42                  ="field 42"
           this.field_43                  ="field 43"
           this.field_44                  ="field 44"
           this.field_45                  ="field 45"
           this.field_46                  ="field 46"
           this.field_47                  ="field 47"
           this.field_48                  ="field 48"
           this.field_49                  ="field 49"
           this.field_50                  ="field 50"

           /* @@ recruiting edit fields */
            this.job                           ="";
            this.notes                         ="";
            this.assign_date                   ="";
            this.rating                        ="";
            this.star_rating                   ="";
            this.labels                        ="";
            this.status                        ="";
            this.candidate_overview            ="";           
            this.ques_ans                      ="";            
            this.disposition                   ="";
            this.resume                        ="";
            this.dealbreakerquescorrect        ="";
            this.duration                      ="";
            this.recent_comp                   ="";
            this.recent_post                   ="";
            this.recent_pay                    ="";
            this.school                        ="";
            this.major                         ="";
            this.degree                        ="";
            this.exp                           ="";
        }
        else
        {
            this.lead_source          = data.lead_source
            this.birth_date            = data.birth_date;
            this.age                   = data.age;
            this.occupation            = data.occupation;
            this.spouse_occupation     = data.spouse_occupation;
            this.spouse_birth_date     = data.spouse_birth_date;
            this.spouse_age            = data.spouse_age;

            this.lender                = data.lender;
            if(data.lender)
                this.lender            = (data.lender).replace(/\&amp;/g, '&');

            this.mortgage_amount       = data.mortgage_amount;
            this.purchase_refi         = data.purchase_refi;
            this.home_value            = data.home_value;
            this.mortgage_term         = data.mortgage_term;
            this.monthly_mortage_payment= data.monthly_mortage_payment;
            this.beneficiary            = data.beneficiary;
            this.smoker                 = data.smoker;

            this.height                 = data.height;
            if(data.height)
                this.height             = (data.height).replace(/\&quot;/g, '"');

            this.weight                 = data.weight;
            this.health_issue           = data.health_issue;
            if(data.health_issue)
                this.health_issue           = (data.health_issue).replace(/\&amp;/g, '&');
            this.spouse_smoker          = data.spouse_smoker;

            this.spouse_height              = data.spouse_height;
            if(data.spouse_height)
                this.spouse_height          = (data.spouse_height).replace(/\&quot;/g, '"');

            this.spouse_weight          = data.spouse_weight;

            this.spouse_health_issue    = data.spouse_health_issue;
            if(data.spouse_health_issue)
                this.spouse_health_issue    = (data.spouse_health_issue).replace(/\&amp;/g, '&');
                
            this.lead_level             = data.lead_level;
            this.assign_date            = data.assign_date;
            this.status                 = data.status;
            this.referrer               = data.referrer;
            this.reason                 = data.reason;
            this.field_1                  = data.field_1
           this.field_2                  = data.field_2
           this.field_3                  = data.field_3
           this.field_4                  = data.field_4
           this.field_5                  = data.field_5
           this.field_6                  = data.field_6
           this.field_7                  = data.field_7
           this.field_8                  = data.field_8
           this.field_9                  = data.field_9
          this.field_10                  = data.field_10
          this.field_11                  = data.field_11
          this.field_12                  = data.field_12
          this.field_13                  = data.field_13
          this.field_14                  = data.field_14
          this.field_15                  = data.field_15
          this.field_16                  = data.field_16
          this.field_17                  = data.field_17
           this.field_18                 = data.field_18
          this.field_19                  = data.field_19
          this.field_20                  = data.field_20
          this.field_21                  = data.field_21
          this.field_22                  = data.field_22
          this.field_23                  = data.field_23
          this.field_24                  = data.field_24
          this.field_25                  = data.field_25
          this.field_26                  = data.field_26
          this.field_27                  = data.field_27
          this.field_28                  = data.field_28
          this.field_29                  = data.field_29
          this.field_30                  = data.field_30
          this.field_31                  = data.field_31
          this.field_32                  = data.field_32
          this.field_33                  = data.field_33
          this.field_34                  = data.field_34
          this.field_35                  = data.field_35
          this.field_36                  = data.field_36
          this.field_37                  = data.field_37
          this.field_38                  = data.field_38
          this.field_39                  = data.field_39
          this.field_40                  = data.field_40
          this.field_41                  = data.field_41
          this.field_42                  = data.field_42
          this.field_43                  = data.field_43
          this.field_44                  = data.field_44
          this.field_45                  = data.field_45
          this.field_46                  = data.field_46
          this.field_47                  = data.field_47
          this.field_48                  = data.field_48
          this.field_49                  = data.field_49
          this.field_50                  = data.field_50

          /* @@ recruiting edit fields */
          this.job                       = data.job;
          this.notes                     = data.notes;
          this.rating                    = data.rating;
          this.star_rating               = data.star_rating;
          this.assign_date               = data.assign_date;
          this.labels                    = data.labels;
          this.status                    = data.status;
          this.candidate_overview        = data.candidate_overview;          
          this.ques_ans                  = data.ques_ans; 
          this.resume                    = data.resume;          
          this.disposition               = data.disposition;
          this.dealbreakerquescorrect    = data.dealbreakerquescorrect;
          this.duration                  = data.duration;
          this.recent_comp               = data.recent_comp;
          this.recent_post               = data.recent_post;
          this.recent_pay                = data.recent_pay;
          this.school                    = data.school;
          this.major                     = data.major;
          this.degree                    = data.degree;
          this.exp                       = data.exp;
        }
    }

    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
            lead_source            :[this.lead_source],
            birth_date             :[this.birth_date],
            age                    :[this.age],
            occupation             :[this.occupation],
            spouse_occupation      :[this.spouse_occupation],
            spouse_birth_date      :[this.spouse_birth_date],
            spouse_age             :[this.spouse_age],
            lender                 :[this.lender],
            mortgage_amount        :[this.mortgage_amount],
            purchase_refi          :[this.purchase_refi],
            home_value             :[this.home_value],
            mortgage_term          :[this.mortgage_term],
            monthly_mortage_payment:[this.monthly_mortage_payment],
            beneficiary            :[this.beneficiary],
            smoker                 :[this.smoker],
            height                 :[this.height],
            weight                 :[this.weight],
            health_issue           :[this.health_issue],
            spouse_smoker          :[this.spouse_smoker],
            spouse_height          :[this.spouse_height],
            spouse_weight          :[this.spouse_weight],
            spouse_health_issue    :[this.spouse_health_issue],
            lead_level             :[this.lead_level],
            assign_date            :[this.assign_date],
            status                 :[this.status],
            referrer               :[this.referrer],
            reason                 :[this.reason],
            field_1                 :[this.field_1],
            field_2                 :[this.field_2],
            field_3                 :[this.field_3],
            field_4                 :[this.field_4],
            field_5                 :[this.field_5],
            field_6                 :[this.field_6],
            field_7                 :[this.field_7],
            field_8                 :[this.field_8],
            field_9                 :[this.field_9],
           field_10                :[this.field_10],
           field_11                :[this.field_11],
           field_12                :[this.field_12],
           field_13                :[this.field_13],
           field_14                :[this.field_14],
           field_15                :[this.field_15],
           field_16                :[this.field_16],
           field_17                :[this.field_17],
           field_18                :[this.field_18],
           field_19                :[this.field_19],
           field_20                :[this.field_20],
           field_21                :[this.field_21],
           field_22                :[this.field_22],
           field_23                :[this.field_23],
           field_24                :[this.field_24],
           field_25                :[this.field_25],
           field_26                :[this.field_26],
           field_27                :[this.field_27],
           field_28                :[this.field_28],
           field_29                :[this.field_29],
           field_30                :[this.field_30],
           field_31                :[this.field_31],
           field_32                :[this.field_32],
           field_33                :[this.field_33],
           field_34                :[this.field_34],
           field_35                :[this.field_35],
           field_36                :[this.field_36],
           field_37                :[this.field_37],
           field_38                :[this.field_38],
           field_39                :[this.field_39],
           field_40                :[this.field_40],
           field_41                :[this.field_41],
           field_42                :[this.field_42],
           field_43                :[this.field_43],
           field_44                :[this.field_44],
           field_45                :[this.field_45],
           field_46                :[this.field_46],
           field_47                :[this.field_47],
           field_48                :[this.field_48],
           field_49                :[this.field_49],
           field_50                :[this.field_50],

           /* @@ recruiting edit fields */
            job                    : [this.job],
            notes                  : [this.notes],
            rating                 : [this.rating],
            star_rating            : [this.star_rating],
            labels                 : [this.labels],
            candidate_overview     : [this.candidate_overview],
            ques_ans               : [this.ques_ans],
            resume                 : [this.resume],
            dealbreakerquescorrect : [this.dealbreakerquescorrect],
            duration               : [this.duration],
            disposition            : [this.disposition],
            recent_comp            : [this.recent_comp],
            recent_post            : [this.recent_post],
            recent_pay             : [this.recent_pay],
            school                 : [this.school],
            major                  : [this.major],
            degree                 : [this.degree],
            exp                    : [this.exp]           
        });
    }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {
            this.lead_source                = fg.get("lead_source").value;

            this.birth_date                = fg.get("birth_date").value;
            this.age                       = fg.get("age").value;
            this.occupation                = fg.get("occupation").value;
            this.spouse_occupation         = fg.get("spouse_occupation").value; 
            this.spouse_birth_date         = fg.get("spouse_birth_date").value; 
            this.spouse_age                = fg.get("spouse_age").value;
            this.lender                    = fg.get("lender").value; 
            this.mortgage_amount           = fg.get("mortgage_amount").value;
            this.purchase_refi             = fg.get("purchase_refi").value;
            this.home_value                = fg.get("home_value").value;
            this.mortgage_term             = fg.get("mortgage_term").value;
            this.monthly_mortage_payment   = fg.get("monthly_mortage_payment").value;
            this.beneficiary               = fg.get("beneficiary").value;
            this.smoker                    = fg.get("smoker").value;
            this.height                    = fg.get("height").value;
            this.weight                    = fg.get("weight").value;
            this.health_issue              = fg.get("health_issue").value;
            this.spouse_smoker             = fg.get("spouse_smoker").value;
            this.spouse_height             = fg.get("spouse_height").value;
            this.spouse_weight             = fg.get("spouse_weight").value;
            this.spouse_health_issue       = fg.get("spouse_health_issue").value;
            this.lead_level                = fg.get("lead_level").value;
            this.assign_date               = fg.get("assign_date").value;
            this.status                    = fg.get("status").value;
            this.referrer                  = fg.get("referrer").value;
            this.reason                    = fg.get("reason").value;
            this.field_1                  = fg.get("field_1").value
            this.field_2                  = fg.get("field_2").value
            this.field_3                  = fg.get("field_3").value
            this.field_4                  = fg.get("field_4").value
            this.field_5                  = fg.get("field_5").value
            this.field_6                  = fg.get("field_6").value
            this.field_7                  = fg.get("field_7").value
            this.field_8                  = fg.get("field_8").value
            this.field_9                  = fg.get("field_9").value
           this.field_10                  = fg.get("field_10").value
           this.field_11                  = fg.get("field_11").value
           this.field_12                  = fg.get("field_12").value
           this.field_13                  = fg.get("field_13").value
           this.field_14                  = fg.get("field_14").value
           this.field_15                  = fg.get("field_15").value
           this.field_16                  = fg.get("field_16").value
           this.field_17                  = fg.get("field_17").value
            this.field_18                 = fg.get("field_18").value
           this.field_19                  = fg.get("field_19").value
           this.field_20                  = fg.get("field_20").value
           this.field_21                  = fg.get("field_21").value
           this.field_22                  = fg.get("field_22").value
           this.field_23                  = fg.get("field_23").value
           this.field_24                  = fg.get("field_24").value
           this.field_25                  = fg.get("field_25").value
           this.field_26                  = fg.get("field_26").value
           this.field_27                  = fg.get("field_27").value
           this.field_28                  = fg.get("field_28").value
           this.field_29                  = fg.get("field_29").value
           this.field_30                  = fg.get("field_30").value
           this.field_31                  = fg.get("field_31").value
           this.field_32                  = fg.get("field_32").value
           this.field_33                  = fg.get("field_33").value
           this.field_34                  = fg.get("field_34").value
           this.field_35                  = fg.get("field_35").value
           this.field_36                  = fg.get("field_36").value
           this.field_37                  = fg.get("field_37").value
           this.field_38                  = fg.get("field_38").value
           this.field_39                  = fg.get("field_39").value
           this.field_40                  = fg.get("field_40").value
           this.field_41                  = fg.get("field_41").value
           this.field_42                  = fg.get("field_42").value
           this.field_43                  = fg.get("field_43").value
           this.field_44                  = fg.get("field_44").value
           this.field_45                  = fg.get("field_45").value
           this.field_46                  = fg.get("field_46").value
           this.field_47                  = fg.get("field_47").value
           this.field_48                  = fg.get("field_48").value
           this.field_49                  = fg.get("field_49").value
           this.field_50                  = fg.get("field_50").value

           /* @@ recruiting edit fields */
           this.job                       = fg.get("job").value;
           this.notes                     = fg.get("notes").value;
           this.rating                    = fg.get("rating").value;
           this.star_rating               = fg.get("star_rating").value;
           this.disposition               = fg.get("disposition").value;
           this.labels                    = fg.get("labels").value;
           this.candidate_overview        = fg.get("candidate_overview").value;
           this.ques_ans                  = fg.get("ques_ans").value;
           this.resume                    = fg.get("resume").value;
           this.dealbreakerquescorrect    = fg.get("dealbreakerquescorrect").value;
           this.duration                  = fg.get("duration").value;
           this.recent_comp               = fg.get("recent_comp").value;
           this.recent_post               = fg.get("recent_post").value;
           this.recent_pay                = fg.get("recent_pay").value;
           this.school                    = fg.get("school").value;
           this.major                     = fg.get("major").value;
           this.degree                    = fg.get("degree").value;            
           this.exp                       = fg.get("exp").value;
            return true;
        }
        else
        {
            return false;
        }
    }
  }

   //End PersonalInfo form

  // Starting Script Form

   export interface Scripts
   {
        id : number,
        script_name:string,
        script_body:string
   }


export interface HTTPScripts
{
    id : number,
    script_name:string,
    script_body:string
}

export class FormScripts implements HTTPScripts{
  public  id : number;
  public script_name:string;
  public script_body:string;
 
    constructor(data : Scripts) 
    {
        console.log("Script current data");
        console.log(data);
        if(data==null)
        {
            this.id=-1;
            this.script_name="";
            this.script_body="";
        }
        else
        {
            this.id  = data.id;
            this.script_name=data.script_name;
            this.script_body=data.script_body;
        }
    }
  }

   //End Script form

    // Starting Comment Form
  
    export interface Comments{
        comments : string
    }
 
 
    export interface HTTPComments
    {
        comments : string,
    }
 
    export class CommentsForm implements HTTPComments{
        public  comments : string;

        constructor(data : Comments) 
        {
            if(data==null)
            {
                this.comments="";
            }
            else
            {
                this.comments  = data.comments;
                
            }
        }
 
     public makeform(fb:FormBuilder):FormGroup
     {
         return fb.group({
           
            comments  : [this.comments],
          
          });
     }
 
     public saveForm(fg:FormGroup):boolean
     {
         if(fg.valid)
         {
 
             this.comments  = fg.get("comments").value;
          
             return true;
         }
         else
         {
             return false;
         }
     }
   }
 
    //End Comment form
 
 // Starting ContactQueue Form

 export interface ContactQueue{
    id       : number,
    queueurl : string,
    county   : string,
    disposition : string
}

export interface HTTPContactQueue
{
    queueurl    : string,
    county      : string,
    disposition : string

}

export class ContactQueue implements HTTPContactQueue{
public  queueurl    : string;
public  county      : string;
public  disposition : string;

  constructor(data : ContactQueue) 
  {
      if(data==null)
      {
          this.queueurl   ="";
          this.county     ="";
          this.disposition="";
      }
      else
      {
          this.queueurl       = data.queueurl;
          this.county         = data.county;
          this.disposition    = data.disposition;
      }
  }

  public makeform(fb:FormBuilder):FormGroup
  {
      return fb.group({
        
        queueurl     : [this.queueurl],
        county       : [this.county],
        disposition  : [this.disposition],
       });
  }

  public saveForm(fg:FormGroup):boolean
  {
      if(fg.valid)
      {

          this.queueurl     = fg.get("queueurl").value;
          this.county       = fg.get("county").value;
          this.disposition  = fg.get("disposition").value;
          return true;
      }
      else
      {
          return false;
      }
  }
}

 //End ContactQueue form


  // Starting Disposition Data Form

export interface DispoData{
    id          : number,
    id_lead     : number,
    id_script   : number,
    disposition : string,
    comments    : string,
    date        : string,
    from_or_contact_time        : string,
    to_or_agent_time            : string,
    from_or_contact_timezone    : string,
    to_or_agent_timezone        : string,
    place       : string,
    client_notify : number,
    appt_duration : string
}


export interface HTTPDispoData
{
    id          : number,
    id_lead     : number,
    id_script   : number,
    disposition : string,
    comments    : string,
    date        : string,
    from_or_contact_time    : string,
    to_or_agent_time      : string,
    from_or_contact_timezone   : string,
    to_or_agent_timezone   : string,
    place       : string,
    client_notify : number
    appt_duration : string
}

export class FormDispoData implements HTTPDispoData{
    public id  : number;
    public id_lead  : number;
    public id_script  : number;
    public disposition : string;
    public comments    : string;
    public date      : string;
    public from_or_contact_time  : string;
    public to_or_agent_time    : string;
    public from_or_contact_timezone : string;
    public to_or_agent_timezone : string;
    public place     : string;
    public client_notify : number;
    public appt_duration : string

  constructor(data : DispoData) 
  {
        if(data==null)
        {
            this.id = -1;
            this.id_lead = -1;
            this.id_script = -1;
            this.disposition = "";
            this.comments = "";
            this.date       = "";
            this.from_or_contact_time   = "";
            this.to_or_agent_time     = "";
            this.from_or_contact_timezone  = "";
            this.to_or_agent_timezone ="";
            this.place      = "";  
            this.client_notify = 0;  
            this.appt_duration = ""
        }
        else
        {
            this.id          = data.id;
            this.id_lead     = data.id_lead;
            this.id_script   = data.id_script;
            this.disposition = data.disposition;
            this.comments    = data.comments;
            this.date       = data.date;
            this.from_or_contact_time   = data.from_or_contact_time;
            this.to_or_agent_time     = data.to_or_agent_time;
            this.from_or_contact_timezone  = data.from_or_contact_timezone;
            this.to_or_agent_timezone = data.to_or_agent_timezone;
            this.place      = data.place;
            this.client_notify = data.client_notify;
            this.appt_duration = data.appt_duration;
        }
  }

  public makeform(fb:FormBuilder):FormGroup
  {
      return fb.group({
        id          : [this.id],
        id_lead     : [this.id_lead],
        id_script   : [this.id_script],
        disposition : [this.disposition],
        comments    : [this.comments],
        date        : [this.date],
        from_or_contact_time    : [this.from_or_contact_time],
        to_or_agent_time      : [this.to_or_agent_time],
        from_or_contact_timezone   : [this.from_or_contact_timezone],
        to_or_agent_timezone        :[this.to_or_agent_timezone],
        place       : [this.place],
        client_notify       : [this.client_notify],
        appt_duration : [this.appt_duration]    
       });
  }

  public saveForm(fg:FormGroup):boolean
  {
      if(fg.valid)
      {
            this.id         = fg.get("id").value;
            this.id_lead    = fg.get("id_lead").value;
            this.id_script  = fg.get("id_script").value;
            this.disposition= fg.get("disposition").value;
            this.comments   = fg.get("comments").value;
            this.date       = fg.get("date").value;
            this.from_or_contact_time   = fg.get("from_or_contact_time").value;
            this.to_or_agent_time     = fg.get("to_or_agent_time").value;
            this.from_or_contact_timezone  = fg.get("from_or_contact_timezone").value;
            this.to_or_agent_timezone  = fg.get("to_or_agent_timezone").value;
            this.place      = fg.get("place").value;
            this.client_notify      = fg.get("client_notify").value;
            this.appt_duration = fg.get("appt_duration").value;
            return true;
      }
      else
      {
          return false;
      }
  }
}

//End Disposition Data form
/* 
export interface ApptCalendar
{
    id          : number,
    id_lead     : number,
    id_script   : number,
    disposition : string,
    comments    : string,
    date        : string,
    from_or_contact_time        : string,
    to_or_agent_time            : string,
    from_or_contact_timezone    : string,
    to_or_agent_timezone        : string,
    place       : string,
    client_notify : number,
    calendar_id:string,
    event_id:number,
    title:string,
    start:Date,
    end:Date,
    email:string,
    alocation:string,
    description:string,
    summview:string,
    start_time:string,
    end_time:string,
    email_reminder:number,
    reminder:number,
    className:string
}

export interface HTTPApptCalendar
{
    id          : number,
    id_lead     : number,
    id_script   : number,
    disposition : string,
    comments    : string,
    date        : string,
    from_or_contact_time        : string,
    to_or_agent_time            : string,
    from_or_contact_timezone    : string,
    to_or_agent_timezone        : string,
    place       : string,
    client_notify : number,
    calendar_id:string,
    event_id:number,
    title:string,
    start:Date,
    end:Date,
    email:string,
    alocation:string,
    description:string,
    summview:string,
    start_time:string,
    end_time:string,
    email_reminder:number,
    reminder:number,
    className:string
}

export class  HTTPApptCalendar{

    public id  : number;
    public id_lead  : number;
    public id_script  : number;
    public disposition : string;
    public comments    : string;
    public date      : string;
    public from_or_contact_time  : string;
    public to_or_agent_time    : string;
    public from_or_contact_timezone : string;
    public to_or_agent_timezone : string;
    public place     : string;
    public client_notify : number;
    public calendar_id:string;
    public event_id:number;
    public title:string;
    public start:Date;
    public end:Date;
    public email:string;
    public alocation:string;
    public description:string;
    public summview:string;
    public start_time:string;
    public end_time:string;
    public email_reminder:number;
    public reminder:number;
    public className:string; 

    constructor(data : ApptCalendar) 
    {
        if(data==null)
        {
            this.id = -1;
            this.id_lead = -1;
            this.id_script = -1;
            this.disposition = "";
            this.comments = "";
            this.date       = "";
            this.from_or_contact_time   = "";
            this.to_or_agent_time     = "";
            this.from_or_contact_timezone  = "";
            this.to_or_agent_timezone ="";
            this.place      = "";  
            this.client_notify = 0;
            this.calendar_id="";  
            this.event_id=-1;
            this.title="";
            this.start=new Date();
            this.end=new Date();
            this.email="";
            this.alocation="";
            this.description="";
            this.summview="";
            this.start_time="";
            this.end_time="";
            this.email_reminder=-1;
            this.reminder=-1;
            this.className="";
        }
        else
        {
            this.id          = data.id;
            this.id_lead     = data.id_lead;
            this.id_script   = data.id_script;
            this.disposition = data.disposition;
            this.comments    = data.comments;
            this.date       = data.date;
            this.from_or_contact_time   = data.from_or_contact_time;
            this.to_or_agent_time     = data.to_or_agent_time;
            this.from_or_contact_timezone  = data.from_or_contact_timezone;
            this.to_or_agent_timezone = data.to_or_agent_timezone;
            this.place      = data.place;
            this.client_notify = data.client_notify;
            this.event_id=data.event_id;
            this.calendar_id=data.calendar_id;
            this.title=data.title;
            this.start=new Date(data.start);
            this.end=new Date(data.end);
            this.email=data.email;
            this.alocation=data.alocation;
            this.description=data.description;
            this.summview=data.summview;
            this.start_time=data.start_time;
            this.end_time=data.end_time;
            this.email_reminder=data.email_reminder;
            this.reminder=data.reminder;
            this.className=data.className;
        }
    }

    public MakeEvent(data:ApptCalendar[], action:CalendarEventAction[], colors:any):CalendarEvent[]
    {
        let ret:CalendarEvent[]=[];
        colors= {
            green: {
              primary: '#0ca12e',
              secondary: '#0ca12e'
            },
            yellow: {
              primary: '#D88E08',
              secondary: '#D88E08'
            },
            blue: {
              primary: '#3a87ad',
              secondary: '#3a87ad'
            }
          };
        for(let row of data)
        {
            let eventcolor:any=colors.blue;
            if(row.className=='green')
                eventcolor=colors.green;
            else if(row.className=='yellow')
                eventcolor=colors.yellow;
            else if(row.className=='blue')
                eventcolor=colors.blue;
            let tmp:CalendarEvent={
                id: row.event_id,
                //title:row.title,
                title:'<b>'+row.title+'</b><br/>'+row.summview,
                start: new Date(row.start),
                end: new Date(row.end),
                //email:row.email,
                //location:row.alocation,
                //description:row.description,
                //content:row.summview,
                color: eventcolor,
                actions: action
            };

            ret.push(tmp);
        }
        return ret;
    }

    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
            id          : [this.id],
            id_lead     : [this.id_lead],
            id_script   : [this.id_script],
            disposition : [this.disposition],
            comments    : [this.comments],
            date        : [this.date],
            from_or_contact_time    : [this.from_or_contact_time],
            to_or_agent_time      : [this.to_or_agent_time],
            from_or_contact_timezone   : [this.from_or_contact_timezone],
            to_or_agent_timezone        :[this.to_or_agent_timezone],
            place       : [this.place],
            client_notify       : [this.client_notify],
            calendar_id :[this.calendar_id],
            title       : [this.title],
            start_time       : [this.start_time],
            end_time     : [this.end_time],
            email       : [this.email],
            email_reminder  : [this.email_reminder],
            reminder    : [this.reminder]
        });
    }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {
                this.id         = fg.get("id").value;
                this.id_lead    = fg.get("id_lead").value;
                this.id_script  = fg.get("id_script").value;
                this.disposition= fg.get("disposition").value;
                this.comments   = fg.get("comments").value;
                this.date       = fg.get("date").value;
                this.from_or_contact_time   = fg.get("from_or_contact_time").value;
                this.to_or_agent_time     = fg.get("to_or_agent_time").value;
                this.from_or_contact_timezone  = fg.get("from_or_contact_timezone").value;
                this.to_or_agent_timezone  = fg.get("to_or_agent_timezone").value;
                this.place      = fg.get("place").value;
                this.calendar_id      = fg.get("calendar_id").value;
                this.title      = fg.get("title").value;
                this.start_time      = fg.get("start_time").value;
                this.end_time        = fg.get("end_time").value;
                this.email      = fg.get("email").value;
                this.email_reminder = fg.get("email_reminder").value;
                this.reminder      = fg.get("reminder").value;
                return true;
        }
        else
        {
            return false;
        }
    }

  }
     */// Starting VoiceDropTemplate  Form


   /*  export interface VoiceDropTemplate{
        id: number,
        vd_msg: string,
        name : string
    }

    export interface HTTPVoiceDropTemplate
    {
        vd_msg: string,
        name : string
    }

    export class FormVoiceDropTemplate implements HTTPVoiceDropTemplate{
        public  vd_msg : string;
        public  name   : string;

        constructor(data : VoiceDropTemplate) 
        {
            if(data==null)
            {
                this.vd_msg ="";
                this.name   ="";
            }
            else
            {
                this.vd_msg = data.vd_msg;
                this.name   = data.name;
            }
        }

        public makeform(fb:FormBuilder):FormGroup
        {
            return fb.group({
                vd_msg   : [this.vd_msg],
                name     : [this.name],
            });
        }

        public saveForm(fg:FormGroup):boolean
        {
            if(fg.valid)
            {
                this.vd_msg = fg.get("vd_msg").value;
                this.name   = fg.get("name").value;
                return true;
            }
            else
            {
                return false;
            }
        }
    } */

    //End VoiceDropTemplate form

    // Starting EmailTemplate  Form

  /*   export interface EmailTemplate{
        id: number,
        name : string,
        template : string
    }

    export interface HTTPEmailTemplate
    {
        id: number,
        name : string,
        template : string
    }

    export class FormEmailTemplate implements HTTPEmailTemplate
    {
        public  id   : number;
        public  name   : string;
        public  template   : string;

        constructor(data : EmailTemplate) 
        {
            if(data==null)
            {
                this.id = -1;
                this.name = "";
                this.template = "";
            }
            else
            {
                this.id = data.id;
                this.name = data.name;
                this.template = data.template;
            }
        }

        public makeform(fb:FormBuilder):FormGroup
        {
            return fb.group({
                id   : [this.id],
                name   : [this.name],
                template   : [this.template]
            });
        }

        public saveForm(fg:FormGroup):boolean
        {
            if(fg.valid)
            {
                this.id = fg.get("id").value;
                this.name = fg.get("name").value;
                this.template = fg.get("template").value;
                return true;
            }
            else
            {
                return false;
            }
        }
    } */

    //End EmailTemplate form

    // Starting SmsTemplate  Form

  /*   export interface SmsTemplate{
        id: number,
        name : string,
        template : string
    }

    export interface HTTPSmsTemplate
    {
        id: number,
        name : string,
        template : string
    }

    export class FormSmsTemplate implements HTTPSmsTemplate
    {
        public  id   : number;
        public  name   : string;
        public  template   : string;

        constructor(data : SmsTemplate) 
        {
            if(data==null)
            {
                this.id = -1;
                this.name = "";
                this.template = "";
            }
            else
            {
                this.id = data.id;
                this.name = data.name;
                this.template = data.template;
            }
        }

        public makeform(fb:FormBuilder):FormGroup
        {
            return fb.group({
                id   : [this.id],
                name   : [this.name],
                template   : [this.template]
            });
        }

        public saveForm(fg:FormGroup):boolean
        {
            if(fg.valid)
            {
                this.id = fg.get("id").value;
                this.name = fg.get("name").value;
                this.template = fg.get("template").value;
                return true;
            }
            else
            {
                return false;
            }
        }
    } */

    //End SmsTemplate form

    

    
/* Appointment Calendar Model */

export interface ApptCalendar
{
    id          : number,
    id_lead     : number,
    id_script   : number,
    disposition : string,
    comments    : string,
    date        : string,
    from_or_contact_time        : string,
    to_or_agent_time            : string,
    from_or_contact_timezone    : string,
    to_or_agent_timezone        : string,
    clients_from_time:string,
    clients_to_time:string,
    place       : string,
    client_notify : number,
    calendar_id:string,
    event_id:number,
    title:string,
    start:Date,
    end:Date,
    email:string,
    alocation:string,
    description:string,
    summview:string,
    start_time:string,
    end_time:string,
    email_reminder:number,
    reminder:number,
    className:string,
    iscallback:number, 
    appt_duration:string
}

export interface HTTPApptCalendar
{
    id          : number,
    id_lead     : number,
    id_script   : number,
    disposition : string,
    comments    : string,
    date        : string,
    from_or_contact_time        : string,
    to_or_agent_time            : string,
    from_or_contact_timezone    : string,
    to_or_agent_timezone        : string,
    clients_from_time:string,
    clients_to_time:string,
    place       : string,
    client_notify : number,
    calendar_id:string,
    event_id:number,
    title:string,
    start:Date,
    end:Date,
    email:string,
    alocation:string,
    description:string,
    summview:string,
    start_time:string,
    end_time:string,
    email_reminder:number,
    reminder:number,
    className:string,
    iscallback:number,
    appt_duration:string
}

export class ApptCalendarForm implements HTTPApptCalendar{

    public id  : number;
    public id_lead  : number;
    public id_script  : number;
    public disposition : string;
    public comments    : string;
    public date      : string;
    public from_or_contact_time  : string;
    public to_or_agent_time    : string;
    public clients_from_time:string;
    public  clients_to_time:string;
    public from_or_contact_timezone : string;
    public to_or_agent_timezone : string;
    public place     : string;
    public client_notify : number;
    public calendar_id:string;
    public event_id:number;
    public title:string;
    public start:Date;
    public end:Date;
    public email:string;
    public alocation:string;
    public description:string;
    public summview:string;
    public start_time:string;
    public end_time:string;
    public email_reminder:number;
    public reminder:number;
    public className:string; 
    public iscallback:number; 
    public appt_duration:string

    constructor(data : ApptCalendar) 
    {
        if(data==null)
        {
            this.id = -1;
            this.id_lead = -1;
            this.id_script = -1;
            this.disposition = "";
            this.comments = "";
            this.date       = "";
            this.from_or_contact_time   = "";
            this.to_or_agent_time     = "";
            this.from_or_contact_timezone  = "";
            this.to_or_agent_timezone ="";
            this.clients_from_time="";
            this.clients_to_time="",
            this.place      = "";  
            this.client_notify = 0;
            this.calendar_id="";  
            this.event_id=-1;
            this.title="";
            this.start=new Date();
            this.end=new Date();
            this.email="";
            this.alocation="";
            this.description="";
            this.summview="";
            this.start_time="";
            this.end_time="";
            this.email_reminder=-1;
            this.reminder=-1;
            this.className="";
            this.iscallback=0; 
            this.appt_duration="00:15"
        }
        else
        {
            this.id          = data.id;
            this.id_lead     = data.id_lead;
            this.id_script   = data.id_script;
            this.disposition = data.disposition;
            this.comments    = data.comments;
            this.date       = data.date;
            this.from_or_contact_time   = data.from_or_contact_time;
            this.to_or_agent_time     = data.to_or_agent_time;
            this.from_or_contact_timezone  = data.from_or_contact_timezone;
            this.to_or_agent_timezone = data.to_or_agent_timezone;
            this.clients_from_time=data.clients_from_time;
            this.clients_to_time=data.clients_to_time
            this.place      = data.place;
            this.client_notify = data.client_notify;
            this.event_id=data.event_id;
            this.calendar_id=data.calendar_id;
            this.title=data.title;
            this.start=new Date(data.start);
            this.end=new Date(data.end);
            this.email=data.email;
            this.alocation=data.alocation;
            this.description=data.description;
            this.summview=data.summview;
            this.start_time=data.start_time;
            this.end_time=data.end_time;
            this.email_reminder=data.email_reminder;
            this.reminder=data.reminder;
            this.className=data.className;
            this.iscallback= data.iscallback; 
            this.appt_duration = data.appt_duration;
        }
    }

    public MakeEvent(data:ApptCalendar[], action:CalendarEventAction[], colors:any):CalendarEvent[]
    {
        let ret:CalendarEvent[]=[];
        colors= {
            green: {
              primary: '#0ca12e',
              secondary: '#0ca12e'
            },
            yellow: {
              primary: '#D88E08',
              secondary: '#D88E08'
            },
            blue: {
              primary: '#3a87ad',
              secondary: '#3a87ad'
            }
          };
        for(let row of data)
        {
            let eventcolor:any=colors.blue;
            if(row.className=='green')
                eventcolor=colors.green;
            else if(row.className=='yellow')
                eventcolor=colors.yellow;
            else if(row.className=='blue')
                eventcolor=colors.blue;
            let tmp:CalendarEvent={
                id: row.event_id,
                //title:row.title,
                title:'<b>'+row.title+'</b><br/>'+row.summview,
                start: new Date(row.start),
                end: new Date(row.end),
                //email:row.email,
                //location:row.alocation,
                //description:row.description,
                //content:row.summview,
                color: eventcolor,
                actions: action
            };

            ret.push(tmp);
        }
        return ret;
    }

    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
            id          : [this.id],
            id_lead     : [this.id_lead],
            id_script   : [this.id_script],
            disposition : [this.disposition],
            comments    : [this.comments],
            date        : [this.date],
            from_or_contact_time    : [this.from_or_contact_time],
            to_or_agent_time      : [this.to_or_agent_time],
            from_or_contact_timezone   : [this.from_or_contact_timezone],
            to_or_agent_timezone        :[this.to_or_agent_timezone],
            clients_from_time:[this.clients_from_time],
            clients_to_time:[this.clients_to_time],
            place       : [this.place],
            client_notify       : [this.client_notify],
            calendar_id :[this.calendar_id],
            title       : [this.title],
            start_time       : [this.start_time],
            end_time     : [this.end_time],
            email       : [this.email],
            email_reminder  : [this.email_reminder],
            reminder    : [this.reminder],
            appt_duration : [this.appt_duration]
        });
    }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {
                this.id         = fg.get("id").value;
                this.id_lead    = fg.get("id_lead").value;
                this.id_script  = fg.get("id_script").value;
                this.disposition= fg.get("disposition").value;
                this.comments   = fg.get("comments").value;
                this.date       = fg.get("date").value;
                this.from_or_contact_time   = fg.get("from_or_contact_time").value;
                this.to_or_agent_time     = fg.get("to_or_agent_time").value;
                this.from_or_contact_timezone  = fg.get("from_or_contact_timezone").value;
                this.to_or_agent_timezone  = fg.get("to_or_agent_timezone").value;
                this.clients_from_time=fg.get("clients_from_time").value;
                this.clients_to_time=fg.get("clients_to_time").value;
                this.place      = fg.get("place").value;
                this.calendar_id      = fg.get("calendar_id").value;
                this.title      = fg.get("title").value;
                this.start_time      = fg.get("start_time").value;
                this.end_time        = fg.get("end_time").value;
                this.email      = fg.get("email").value;
                this.email_reminder = fg.get("email_reminder").value;
                this.reminder      = fg.get("reminder").value;
                this.appt_duration = fg.get("appt_duration").value;
                return true;
        }
        else
        {
            return false;
        }
    }

  }

    // Starting VoiceDropTemplate  Form


    /* Objection Button Model Start */
    export interface Objection
    {
        id      ?: any[];
        objection_name ?: any[];
        objection   : string;
        iduser : number;
        color:string
    }
   
    
/* Question Model Start */
export interface Questions 
{    
    // candidateid:number,
    uscitizon:string,
    worktimezone:string,
    isfelony:string,
    previousemployment:string,
    mostlike:string,
    leastlike:string,
    income:string,
    corporateview:string,
    agenttype:string,
    agentanswer:string,
    bestyou:string,
    courseaction:string,
    havelifeinsurance:boolean,
    feelgood:string,
    knowcompany:string
}

export interface HTTPQuestions 
{ 
    // candidateid:number,
    uscitizon:string,  
    worktimezone:string,
    isfelony:string,
    previousemployment:string,
    mostlike:string,
    leastlike:string,
    income:string,
    corporateview:string,
    agenttype:string,
    agentanswer:string,
    bestyou:string,
    courseaction:string,
    havelifeinsurance:boolean,
    feelgood:string,
    knowcompany:string
}

export class QuestionsForm implements HTTPQuestions {   
    
    // public candidateid:number;
    public uscitizon:string;
    public worktimezone:string;
    public isfelony:string;
    public previousemployment:string;
    public mostlike:string;
    public leastlike:string;
    public income:string;
    public corporateview:string;
    public agenttype:string;
    public agentanswer:string;
    public bestyou:string;
    public courseaction:string;
    public havelifeinsurance:boolean;
    public feelgood:string;
    public knowcompany:string
    constructor(data:Questions)
    {
        if(data==null)
        {
            // this.candidateid=-1;
            this.uscitizon="";
            this.worktimezone="";
            this.isfelony="";
            this.previousemployment="";
            this.mostlike="";
            this.leastlike="";
            this.income="";
            this.corporateview="";
            this.agenttype="";
            this.agentanswer="";
            this.bestyou="";
            this.courseaction="";
            this.havelifeinsurance=null;
            this.feelgood="";
            this.knowcompany="";
        }
        else
        {
            // this.candidateid=data.candidateid;
            this.uscitizon=data.uscitizon;
            this.worktimezone=data.worktimezone;
            this.isfelony=data.isfelony;
            this.previousemployment=data.previousemployment;
            this.mostlike=data.mostlike;
            this.leastlike=data.leastlike;
            this.income=data.income;
            this.corporateview=data.corporateview;
            this.agenttype=data.agenttype;
            this.agentanswer=data.agentanswer;
            this.bestyou=data.bestyou;
            this.courseaction=data.courseaction;
            this.havelifeinsurance=data.havelifeinsurance;
            this.feelgood=data.feelgood;
            this.knowcompany=data.knowcompany;
        }
    }

    
    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
            uscitizon: [this.uscitizon],
            worktimezone: [this.worktimezone],
            isfelony: [this.isfelony],
            previousemployment: [this.previousemployment],
            mostlike: [this.mostlike],
            leastlike: [this.leastlike],
            income: [this.income],
            corporateview: [this.corporateview],
            agenttype: [this.agenttype],
            agentanswer: [this.agentanswer],
            bestyou: [this.bestyou],
            courseaction: [this.courseaction],
            havelifeinsurance: [this.havelifeinsurance],
            feelgood: [this.feelgood],
            knowcompany:[this.knowcompany]
            //emailtemplate: [this.emailtemplate]
        });
    }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {
            this.uscitizon=fg.get("uscitizon").value;
            this.worktimezone=fg.get("worktimezone").value;
            this.isfelony=fg.get("isfelony").value;
            this.previousemployment=fg.get("previousemployment").value;
            this.mostlike=fg.get("mostlike").value;
            this.leastlike=fg.get("leastlike").value;
            this.income=fg.get("income").value;
            this.corporateview=fg.get("corporateview").value;
            this.agenttype=fg.get("agenttype").value;
            this.agentanswer=fg.get("agentanswer").value;
            this.bestyou=fg.get("bestyou").value;
            this.courseaction=fg.get("courseaction").value;
            this.havelifeinsurance=fg.get("havelifeinsurance").value;
            this.feelgood=fg.get("feelgood").value;
            this.knowcompany=fg.get("knowcompany").value;
            //this.emailtemplate=fg.get("emailtemplate").value;
            return true;
        }
        else
        {
            return false;
        }
    }

}